import Component from 'vue-class-component';
import { Vue } from 'vue-property-decorator';
import ExternalIncomeItemComponent from '@/views/dashboard/form101/steps/tax-details-step/external-income-table/external-income-item/external-income-item.component';
import { ExternalIncomeItem } from '@/views/dashboard/form101/steps/tax-details-step/external-income-table/models/external-income-item.model';
import { Getter, Mutation } from 'vuex-class';
import { ADD_EXTERNAL_INCOME, FORM101_DATA, REMOVE_EXTERNAL_INCOME } from '@/types/form.types';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { Form101DataModel } from '@/models/form/Form101Data.model';

@Component({
  components: {
    ExternalIncomeItemComponent
  }
})

export default class ExternalIncomeTableComponent extends Vue {


  @Mutation(ADD_EXTERNAL_INCOME, StoreNamespace.FORM) public addExternalIncome;
  @Mutation(REMOVE_EXTERNAL_INCOME, StoreNamespace.FORM) public removeExternalIncome;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;

  public created() {
    if (this.form101Data.externalIncomeDetails) {
      for (const income of this.form101Data.externalIncomeDetails) {
        income.uniqueId = '' + (Math.random() * 10000);
      }
    }
  }

  public addItem() {
    const income: ExternalIncomeItem = {
        externalIncomeEmployerName: '',
        externalIncomeEmployerAddress: '',
        externalIncomeDeductionNumber: null,
        externalIncomeIncomeType: null,
        externalIncomeMonthlyIncomeAmount: null,
        externalIncomeMonthlyIncomeTaxAmount: null,
        uniqueId: '' + (Math.random() * 10000),
      } as ExternalIncomeItem;
    this.addExternalIncome(income);
  }
}
